import { TRuleSet } from "./store"

export function extractRightOperandName(
	values: TRuleSet["right_operand_value"]
): string | string[] | undefined {
	if (!values) return undefined

	if (typeof values === "string" || typeof values === "number") {
		return String(values)
	}

	if (Array.isArray(values)) {
		return values.map((v) =>
			typeof v === "string" || typeof v === "number"
				? String(v)
				: String(v.id ?? v.name)
		)
	}
	if ("id" in values || "name" in values) {
		return String(values.id ?? values.name)
	}

	return undefined
}
